import {
  Typography as MuiTypography,
  styled,
  css,
  Box as MuiBox,
} from '@mui/material';
import { TextField as _TextField } from '~/components/commons/TextField';
import { Button as _Button } from '~/components/commons/Button';
import { ComboBox as _ComboBox } from '~/components/commons/ComboBox';
import { DropdownList as _DropdownList } from '~/components/commons/DropdownList_v1';
import { SearchFilterRangeInput as _SearchFilterRangeInput } from '~/components/commons/SearchFilterRangeInput';

export const DropdownList = styled(_DropdownList)`
  height: 34px;
  .MuiAutocomplete-inputRoot.MuiInputBase-root.MuiOutlinedInput-root {
    height: 34px;
  }
`;

export const Box = styled(MuiBox)(
  () => `
  &.h-full {
    height : 100%;
  }

  &.bg-white {
    background-color : #fff;    
  }
`
);

export const SearchFilterRangeInput = styled(_SearchFilterRangeInput)(
  () => `
    &.account-count {
      .label-text {
        width: 120px;
      }
    }
    &.pen-chart-account-bucket-size {
      .label-text {
        width: 180px;
      }
    }
  `
);

export const TextField = styled(_TextField)(
  () => `
    height: 34px;
  `
);

export const ComboBox = styled(_ComboBox)(
  () => `
    height: 34px;
    .MuiAutocomplete-inputRoot.MuiInputBase-root.MuiOutlinedInput-root {
      height: 34px;
    }
  `
);

export const Typography = styled(MuiTypography)(
  () => `
    width: 64px;
    font-size: 12px;
    font-weight: 500;
    padding-left: 8px;
    font-weight: 500;
    word-break: keep-all;

    &.width-wide {
      width: 80px;
    }
  `
);

export const Button = styled(_Button)`
  height: 34px;

  &.search-btn {
    margin-left: 0.5rem;
  }
`;

export const ChargeRefundButton = styled(_Button)`
  width: 120px;
  height: 29px;
`;

export const ButtonContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ExcelDownloadButton = styled(_Button)`
  width: 120px;
  height: 29px;
`;
